var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-index',{attrs:{"tableColCheck":_vm.tableColCheck,"plat-name":"metag"},scopedSlots:_vm._u([{key:"projectSign",fn:function({text,record}){return _c('span',{},[_c('el-tag',{attrs:{"round":"","type":text==='normal'?'primary':'warning'}},[_vm._v(_vm._s(text))])],1)}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }